module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.b8cf87d7.svg";